<template>
  <div>
    <div v-if="selectedBuildingInfo">
      <v-card flat>
        <!-- <v-card-title>
          Floorplan
        </v-card-title> -->
        <v-row>
          <v-col cols="12" md="4">
            <!-- <h2>Plan dropdown</h2> -->
            <v-autocomplete outlined dense style="z-index: 9999"
                      :items="planSelectDropdownItems"
                      v-model="selectedPlanId"
                      label="SELECT FLOOR PLAN"
            ></v-autocomplete>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" md="6" style="text-align: right;" v-if="kiosk !== 10">
            <v-btn
              class="layer-btn"
              :style="{
            backgroundColor : peopleLayer ? 'black !important' : '',
            color: peopleLayer ? 'white !important' : 'black'}"
              large tile depressed
              :outlined="peopleLayer ? true : false"
              @click="togglePeopleLayer">People
            </v-btn>
            <v-btn
              class="layer-btn"
              :style="{
            backgroundColor : spaceLayer ? 'black !important' : '',
            color: spaceLayer ? 'white !important' : 'black'}"
              large tile depressed
              :outlined="spaceLayer ? true : false"
              @click="toggleSpaceLayer">Availability
            </v-btn>
            <!-- <v-btn
              :style="{
            backgroundColor : sensorLayer ? 'black !important' : '',
            color: sensorLayer ? 'white !important' : 'black'}"
              class="layer-btn"
              large tile depressed
              :outlined="sensorLayer ? true : false"
              @click="toggleSensorLayer"
            >Sensors
            </v-btn> -->
            <v-menu offset-y z-index="1001">
              <template v-slot:activator="{ on }">
                <v-btn
                  class="layer-btn"
                  large tile depressed
                  :outlined="sensorLayer ? true : false"
                  v-on="on">{{ sensorLayer === false ? "Sensors" : sensorLayer }}
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="toggleSensorLayer('Sensor Status')">
                  <v-list-item-title>Sensor Status</v-list-item-title>
                </v-list-item>
                <v-list-item @click="toggleSensorLayer('Sensor Type')">
                  <v-list-item-title>Sensor Type</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-menu offset-y z-index="1001">
              <template v-slot:activator="{ on }">
                <v-btn
                  class="layer-btn"
                  large tile depressed
                  :outlined="environmentLayer ? true : false"
                  v-on="on">{{ environmentLayer === false ? "Heatmap" : environmentLayer }}
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="toggleEnvironmentLayer('temperature')">
                  <v-list-item-title>Temperature</v-list-item-title>
                </v-list-item>
                <v-list-item @click="toggleEnvironmentLayer('co2')">
                  <v-list-item-title>CO2</v-list-item-title>
                </v-list-item>
                <v-list-item @click="toggleEnvironmentLayer('humid')">
                  <v-list-item-title>Humidity</v-list-item-title>
                </v-list-item>
                <v-list-item @click="toggleEnvironmentLayer('occupancy')">
                  <v-list-item-title>Occupancy</v-list-item-title>
                </v-list-item>
                 <v-list-item @click="toggleEnvironmentLayer('voc')">
                  <v-list-item-title>VOC</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
        <div v-if='validPlan'>
          <SpaceMap
            :building="selectedBuildingInfo"
            :plan="selectedPlan"
            :managedSpaces="planManagedSpaces"
            :sensorReadings="selectedBuildingSensorReadings"
            :sensorLayer="sensorLayer"
            :spaceLayer="spaceLayer"
            :occupancyLayer="occupancyLayer"
            :peopleLayer="peopleLayer"
            :environmentLayer="environmentLayer"
          ></SpaceMap>
        </div>
        <div>
          <v-row v-if="debug">
            <v-col cols="12">
              <v-card>
                <v-card-title>Plan Debug</v-card-title>
                <!-- <p>Plans: {{ plansForBuilding }}</p> -->
                <p>Plan Dropdown Items (planDropdownItems) {{ planSelectDropdownItems }}</p>
                <p>Selected Plan Id From List: (selectedPlanId) {{ selectedPlanId }}</p>
                <p>Valid Plan: (validPlan) {{ validPlan }}</p>
                <p>Selected Plan: {{ selectedPlan }}</p>
                <p>Managed spaces for building with Readings (managedSpaces): {{ managedSpaces }}</p>
                <p>Plan Managed Spaces With Readings: {{ planManagedSpaces }}</p>
                <p>Sensor layer: {{ sensorLayer }}</p>
                <p>Sensor readings for building: {{ selectedBuildingSensorReadings }}</p>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
// import { mapState } from 'vuex'
import SpaceMap from '../components/SpaceMap'
import { mapState } from 'vuex'

export default {
  name: 'plan',
  components: {
    SpaceMap
  },
  data: () => {
    return {
      selectedPlanId: null,
      sensorLayer: false,
      spaceLayer: true,
      occupancyLayer: false,
      peopleLayer: false,
      environmentLayer: false,
      debug: false
    }
  },
  computed: mapState({
    // Get from building store
    selectedBuildingInfo: function () {
      return this.$store.state.building.selectedBuildingInfo
    },
    managedSpaces: function () {
      return this.$store.state.building.managedSpaces
    },
    kiosk: state => state.auth.kiosk,
    selectedBuildingSensorReadings: function () {
      return this.$store.state.building.selectedBuildingSensorReadings
    },

    // Derived computed values
    plansForBuilding: function () {
      // console.log(this.selectedBuildingInfo)
      if (this.selectedBuildingInfo === null) {
        return null
      }
      return this.selectedBuildingInfo.planbuilding_set
        .filter(plan => plan.shown)
    },
    selectedPlan: function () {
      if (this.plansForBuilding === null) {
        return null
      }
      let filteredPlanList = this.plansForBuilding.filter(plan => plan.id === this.selectedPlanId)
      // console.log(filteredPlanList)
      // console.log(this.selectedPlanId)
      if (filteredPlanList.length > 0) {
        return filteredPlanList[0]
      }
      return null
    },
    planManagedSpaces: function () {
      if (this.selectedPlanId === null) {
        return []
      }
      if (this.managedSpaces === null) {
        return []
      }
      return this.managedSpaces.filter(space => {
        return space.planmanagedspacelocation_set.filter(plan => plan.planbuilding === this.selectedPlanId).length > 0
      })
    },
    validPlan: function () {
      return this.selectedPlan !== null
    },
    planSelectDropdownItems: function () {
      let result = []
      // console.log(this.plansForBuilding)
      if (this.plansForBuilding !== null) {
        for (let plan of this.plansForBuilding) {
          result.push({
            text: plan.name,
            value: plan.id
          })
        }
      }
      return result
    }
  }),
  methods: {
    toggleSensorLayer: function (val) {
      if (this.sensorLayer === val) {
        this.sensorLayer = false
      } else {
        this.sensorLayer = val
      }
    },
    toggleSpaceLayer: function () {
      this.spaceLayer = !this.spaceLayer
    },
    toggleOccupancyLayer: function () {
      this.occupancyLayer = !this.occupancyLayer
    },
    togglePeopleLayer: function () {
      this.peopleLayer = !this.peopleLayer
    },
    toggleEnvironmentLayer: function (val) {
      if (this.environmentLayer === val) {
        this.environmentLayer = false
      } else {
        this.environmentLayer = val
      }
    }
  },
  watch: {
    planSelectDropdownItems: {
      handler (val, oldVal) {
        // console.log('planSelectDropdownItems changed')
      },
      deep: true
    }
  },
  mounted () {
    this.selectedPlanId = this.planSelectDropdownItems[0].value
  }
}
// selectedBuildingInfo: {
//   // This will let Vue know to look inside the array
//   deep: true,
//
//   // We have to move our method to a handler field
//   handler () {
//     console.log('selectedBuildingInfo changed!')
//   }
// },
// plansForBuilding: {
//   // This will let Vue know to look inside the array
//   deep: true,
//
//   // We have to move our method to a handler field
//   handler () {
//     console.log('plans for building changed!')
//   }
// },
// planSelectDropdownItems: {
//   // This will let Vue know to look inside the array
//   deep: true,
//
//   // We have to move our method to a handler field
//   handler () {
//     console.log('planSelectDropdownItems changed!')
//   }
// },
// managedSpaces: {
//   // This will let Vue know to look inside the array
//   deep: true,
//
//   // We have to move our method to a handler field
//   handler () {
//     console.log('managed spaces changed!')
//   }
// }
// }
// }
</script>

<style scoped>
.layer-btn {
  margin-right: 10px;
  font-family: 'NeutrifPro-Bold', serif;
  font-size: 10px;
  letter-spacing: 3px;
}
</style>
